// extracted by mini-css-extract-plugin
export var caption = "Image-module--caption--8b7d0";
export var container = "Image-module--container--15b17";
export var dropdown = "Image-module--dropdown--eb6d1";
export var dropdownToggle = "Image-module--dropdownToggle--b4eed";
export var img = "Image-module--img--b87cd";
export var isBreakout = "Image-module--isBreakout--c4f8e";
export var isPrimary = "Image-module--isPrimary--64f6b";
export var label = "Image-module--label--3143f";